import { render, staticRenderFns } from "./pos-close-shift.vue?vue&type=template&id=365f986a&"
import script from "./pos-close-shift.vue?vue&type=script&lang=js&"
export * from "./pos-close-shift.vue?vue&type=script&lang=js&"
import style0 from "./pos-close-shift.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
